import actions from "./actions";

const initState = {
  productProfitabilityData: [],
  loading: false,
};

export default function productProfitabilityReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_PRODUCT_PROFITABILITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_PRODUCT_PROFITABILITY_SUCCESS:
      return {
        ...state,
        productProfitabilityData: action.productProfitabilityData,
        loading: false,
      };
    default:
      return state;
  }
}
